import styled from 'styled-components';

export const StyledContainer = styled.div`
    min-height: 100vh;
    width: 100%;
    overflow: hidden;
    background-color: ${(p) => p.theme.colors.secondary};
    display: flex;
`;
